@use "../../style/mixins" as *;
@use "../../style/variables" as *;

.container {
  display: flex;
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;

  .column {
    flex: 1 0 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .left {
      @include mobile {
        img {
          max-width: 100%;
        }
      }
    }

    .right {
      width: 12rem;
      text-align: center;

      @include mobile {
        width: 80%;
      }

      .textBlock {
        margin-bottom: 4rem;

        @include mobile {
          margin-bottom: 2rem;
        }

        .text {
          font-weight: 300;
          font-size: 1.125rem;
          color: $grey-text;
          line-height: 1.5rem;

          @include mobile {
            font-size: 0.75rem;
            line-height: 1.125rem;
          }
        }
      }

      .logo {
        margin-bottom: 0.75rem;

        .img {
          height: 43px;
        }
      }
    }
  }
}
